import { Proposal } from "@/models/proposal";
import { Pagination } from "@/models/pagination";
import { IProposal, ProposalState } from "@/types/proposal";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<ProposalState, IProposal> = {
  single: (state, single) => {
    state.single = new Proposal(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Proposal(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Proposal();
    state.pagination = new Pagination();
  },
};

export default mutations;
